import { useMemo } from "react";
import { useCompanyPreferences } from "../../../Settings/Configuration/hooks/usePreferences";

export type QualificationField = "skills" | "licenses" | "certifications";

// Qualifications are only shown when enabled in the company's general schedule settings.
export const useQualificationPreferences = (): Record<QualificationField, boolean> => {
    const preferences = useCompanyPreferences("scheduleSettings");

    return useMemo(() => ({
        skills: !!preferences?.skills,
        licenses: !!preferences?.licenses,
        certifications: !!preferences?.certifications,
    }), [preferences]);
};
